import { Component, Input, OnInit } from '@angular/core';

import {Document, DocumentService} from '../../../common/services';
import {finalize} from 'rxjs/operators';
import {PubSubService} from '../../../common/services/pub-sub.service';


@Component({
  selector: 'p8-bdc-document-form',
  templateUrl: './document-form.component.html',
  styleUrls: ['./document-form.component.scss']
})
export class DocumentFormComponent implements OnInit {
  @Input() file: File;
  @Input() title: string;

  constructor(private documentService: DocumentService,
              private pubSubService: PubSubService) { }

  ngOnInit() {
    if (this.file) {
      this.title = this.file.name;
    }
  }

  save() {
    const newDocument: Document = {
      title: this.title,
      file: this.file
    };

    this.pubSubService.publish('loading', true);

    return this.documentService
      .upload(newDocument)
      .pipe(finalize(() => this.pubSubService.publish('loading', false)));
  }

  patch(id: number) {
    const doc: Document = {
      id: id,
      title: this.title
    };

    this.pubSubService.publish('loading', true);

    return this.documentService
      .patch(doc)
      .pipe(finalize(() => {
        this.pubSubService.publish('loading', false);
      }));
  }
}
